export default __webpack_public_path__ + "static/media/hv-logo-footer.71bc9a4a.svg";